import { STATUSPAGE, SUBMIT_BUTTON } from '@repo/ui';
import { HandleActivitiesAnalyticalPerTaskUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  clearTasksData,
  loadTasksData,
} from 'presentation/config/store/reports/activities-analytical-per-task';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useActivitiesAnalyticalPerTask = () => {
  const { reportService } = useService();

  const [selectedSubmitBtn, setSelectedSubmitBtn] =
    useState<SUBMIT_BUTTON | null>(null);
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [loading, setLoading] = useState({
    loadingButtons: STATUSPAGE.DONE,
    loadingTable: STATUSPAGE.DONE,
  });

  const dispatch = useDispatch();

  const { tasksData, filters } = useAppSelector(
    (state) => state.activitiesAnalyticalPerTask,
  );

  // Methods
  const toggleLoading = (key: string, status: STATUSPAGE) => {
    setLoading((prevState) => ({
      ...prevState,
      [key]: status,
    }));
  };

  const requestHandleActivitiesAnalyticalPerTaskPDFOrExcel = useCallback(
    async (
      params: HandleActivitiesAnalyticalPerTaskUseCaseInterface.Params,
    ) => {
      toggleLoading('loadingButtons', STATUSPAGE.LOADING);
      await reportService
        .handleActivitiesAnalyticalPerTask(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === SUBMIT_BUTTON.PDF ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          toggleLoading('loadingButtons', STATUSPAGE.ERROR);
          notifyError(err.message);
        })
        .finally(() => {
          toggleLoading('loadingButtons', STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestHandleActivitiesAnalyticalPerTaskJSON = useCallback(
    async (
      params: HandleActivitiesAnalyticalPerTaskUseCaseInterface.Params,
    ) => {
      toggleLoading('loadingButtons', STATUSPAGE.LOADING);
      toggleLoading('loadingTable', STATUSPAGE.LOADING);
      await reportService
        .handleActivitiesAnalyticalPerTask(params)
        .then((res) => {
          dispatch(loadTasksData(res));
        })
        .catch((err) => {
          toggleLoading('loadingButtons', STATUSPAGE.ERROR);
          toggleLoading('loadingTable', STATUSPAGE.ERROR);
          notifyError(err.message);
          dispatch(clearTasksData());
        })
        .finally(() => {
          toggleLoading('loadingButtons', STATUSPAGE.DONE);
          toggleLoading('loadingTable', STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );

  return {
    // States
    filters,
    loading,
    tasksData,
    hasFetchedData,
    selectedSubmitBtn,
    // Methods
    requestHandleActivitiesAnalyticalPerTaskJSON,
    requestHandleActivitiesAnalyticalPerTaskPDFOrExcel,
    setSelectedSubmitBtn,
  };
};
